import { clsx } from 'clsx'
import { type FC } from 'react'

import { Option } from 'base-ui'

import { type SelectionEntry } from '../../../product-page-context/useProductPageAttributeSelectionControls'
import { productPageGetAttributeSelectionEntryConditions } from '../ProductPageAttributeSelector/productPageGetAttributeSelectionEntryConditions'

export const ProductPageListTypeAttributeGroupSelectOption: FC<{
  value: SelectionEntry
}> = ({ value }) => {
  const {
    candidateIsNotBuyable,
    notSelectedAndNoVariants,
    selectedButNoVariants,
  } = productPageGetAttributeSelectionEntryConditions(value)

  return (
    <Option
      className={clsx(
        (candidateIsNotBuyable ||
          notSelectedAndNoVariants ||
          selectedButNoVariants) &&
          'text-dark-primary-low',
      )}
      value={value}
    >
      {value.attribute.value}
    </Option>
  )
}
